import React, { Component } from 'react';
import {
    Label,
    Row,
    Col,
} from 'reactstrap';
import './Contacts.css';
import CopyString from '../CopyString/CopyString';

class ListContacts extends Component {
    constructor(props) {
        super(props);
        this.createdTS = parseInt(String(props.row.created).substr(5, 2)) + '/' + parseInt(String(props.row.created).substr(8, 2)) + '/' + String(props.row.created).substr(2, 2);
        this.updatedTS = parseInt(String(props.row.timestamp).substr(5, 2)) + '/' + parseInt(String(props.row.timestamp).substr(8, 2)) + '/' + String(props.row.timestamp).substr(2, 2);
    }

    displayType = (validation, item) => {
        const displayType = this.props.notesCategories.find(notesCategory => notesCategory.type === validation);
        if (displayType && displayType.validation === 'list') {
            const retStr = displayType.list?.find(listItem => parseInt(listItem.ID) === parseInt(item))?.description || ''
            return retStr;
        }
        switch (validation) {
            case "checkbox":
                return (item === 'true') ? "Yes" : "No"
            default:
                return item;
        }
    }

    parsePhone = (val) => {
        if (val.length !== 10 || isNaN(val)) return val;
        return `(${val.substring(0, 3)}) ${val.substring(3, 6)}-${val.substring(6, 10)}`;
    }

    render() {
        const dt = this.displayType;
        return (
            <Row key={this.props.row.linkedID} className="notesFormTypeRow pointer" onClick={() => this.props.handleEditSwap(this.props.row.linkedID)}>
                <Col sm={9} className="notesFormTypeComments text-left"><>
                    <Row className="notesFormCommentRow">
                        <Col md={5} className="border-bottom pb-1 pt-1">
                            {this.props.row.children['Contact Name'] != null ? this.props.row.children['Contact Name'] : ''}
                        </Col>
                        <Col md={7} className="border-bottom pb-1 pt-1">
                            {this.props.row.children['Title'] != null ? this.props.row.children['Title'] : ''}
                        </Col>
                    </Row>
                    <Row className="notesFormCommentRow">
                        <Col md={5} className="border-bottom pb-1 pt-1">
                            {this.props.row.children['Phone Number'] != null && <div>{this.parsePhone(this.props.row.children['Phone Number'])}</div>}
                            {this.props.row.children['Phone Number (Office)'] != null && <div>{this.parsePhone(this.props.row.children['Phone Number (Office)'])} <span className="commentTag">Office</span></div>}
                            {this.props.row.children['Phone Number (Mobile)'] != null && <div>{this.parsePhone(this.props.row.children['Phone Number (Mobile)'])} <span className="commentTag">Mobile</span></div>}
                            {this.props.row.children['Phone Number (Personal)'] != null && <div>{this.parsePhone(this.props.row.children['Phone Number (Personal)'])} <span className="commentTag">Personal</span></div>}
                            {this.props.row.children['Phone Number (Home)'] != null && <div>{this.parsePhone(this.props.row.children['Phone Number (Home)'])} <span className="commentTag">Home</span></div>}
                        </Col>
                        <Col md={7} className="border-bottom pb-1 pt-1">
                            {this.props.row.children['Email Address'] != null && <div style={{ textWrap: 'nowrap' }}><CopyString textToCopy={this.props.row.children['Email Address']} />&nbsp;{this.parsePhone(this.props.row.children['Email Address'])}</div>}
                            {this.props.row.children['Email Address (Office)'] != null && <div>{this.parsePhone(this.props.row.children['Email Address (Office)'])} <span className="commentTag">Office</span></div>}
                            {this.props.row.children['Email Address (Personal)'] != null && <div>{this.parsePhone(this.props.row.children['Email Address (Personal)'])} <span className="commentTag">Personal</span></div>}
                        </Col>
                    </Row>
                    {this.props.row.children['LinkedIn URL'] != null && <Row className="notesFormCommentRow">
                        <Col md={5} className="border-bottom pb-1 pt-1"><Label><img className="cssi-icon" src="/linkedIn.png" alt="LinkedIn URL" /> LinkedIn URL</Label>
                        </Col>
                        <Col md={7} className="border-bottom pb-1 pt-1">
                            {<div style={{ textWrap: 'nowrap' }}><CopyString textToCopy={this.props.row.children['LinkedIn URL']} />&nbsp;<a href={this.props.row.children['LinkedIn URL']} onClick={(e) => e.stopPropagation()} target="_blank" rel="noopener noreferrer">{this.props.row.children['LinkedIn URL']}</a></div>}
                        </Col>
                    </Row>}
                    {Object.keys(this.props.row.children).filter(child => ((child !== 'Contact Name' && child !== 'Title' && child.indexOf('LinkedIn URL') === -1 && child.indexOf('Email Address') === -1 && child.indexOf('Phone Number') === -1) && child.indexOf('Inactive') === -1))
                        .map((comment, index) =>
                        (<Row key={comment.ID + '_' + index} className="notesFormCommentRow">
                            <Col sm={5} className={(index < Object.keys(this.props.row.children).length - 1 ? "border-bottom pb-1 " : "") + "pt-1"}>
                                <Label>{comment}</Label>
                            </Col>
                            <Col sm={7} className={(index < Object.keys(this.props.row.children).length - 1 ? "border-bottom pb-1 " : "") + "pt-1"}>
                                {
                                    (Array.isArray(this.props.row.children[comment]) ?
                                        this.props.row.children[comment] :
                                        String(this.props.row.children[comment]).split("\n")).map(function (item, idx) {
                                            const displayType = dt(comment, item);
                                            return (
                                                <div /*key={item}*/ key={idx}>
                                                    {displayType}
                                                    <br />
                                                </div>
                                            )
                                        })
                                }
                            </Col>
                        </Row>))}
                    {!this.props.row.active && <Row className="notesFormCommentRow">
                        <Col sm={5} className="border-bottom pb-1 pt-1">
                            <Label>Active</Label>
                        </Col>
                        <Col sm={7} className="border-bottom pb-1 pt-1">
                            No
                        </Col>
                    </Row>}
                </>
                </Col>
                <Col sm={3} className="notesFormTypeControls text-right">
                    <div className="noteCreatedTimestamp" >
                        {this.createdTS}
                    </div>
                    {this.createdTS !== this.updatedTS ?
                        <div className="noteUpdatedTimestamp" title={String(this.props.row.timestamp).substr(11, 2) + ':' + String(this.props.row.timestamp).substr(14, 2) + ' by ' + this.props.row.user.firstName + ' ' + this.props.row.user.lastName}>
                            {this.updatedTS}
                        </div> : <></>}
                    <div className="noteCreatedTimestamp" title={String(this.props.row.timestamp).substr(11, 2) + ':' + String(this.props.row.timestamp).substr(14, 2) + ' by ' + this.props.row.user.firstName + ' ' + this.props.row.user.lastName}>
                        {this.props.row.user.firstName + ' ' + this.props.row.user.lastName}
                    </div>
                </Col>
            </Row>
        )
    }
}

export default ListContacts;
